import { render, staticRenderFns } from "./AppInterfacesEventsChartWrapper.vue?vue&type=template&id=378b3bee&"
import script from "./AppInterfacesEventsChartWrapper.vue?vue&type=script&lang=js&"
export * from "./AppInterfacesEventsChartWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AppInterfacesEventsChartWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSelect,VSpacer})
